"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConfiguration = void 0;
function getConfiguration() {
    return {
        serverURL: 'https://transactions-api.decentraland.io/v1'
    };
}
exports.getConfiguration = getConfiguration;
//# sourceMappingURL=configuration.js.map